/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@import url(https://js.arcgis.com/4.10/esri/css/main.css);.esri-view[_ngcontent-%COMP%]{height:420px!important}\n/*# sourceMappingURL=esri-map.component.css.map*/"];
export { styles as styles };
